import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'BackButton';

export default class BackButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
		}
	}

	markup() {
		return `
		  <button class="${this.classPrefix}__form-back-button lta-navigational-btn lta-navigational-btn--responsive" aria-label="Go back">
		    <svg class="lta-icon js-lta-text-input--btn-icon lta-navigational-icon" width="1em" height="1em" fill="currentColor" alt="arrow-left-circle" aria-hidden="true">
		      <use xlink:href="/static/images/icons/lta-icons.svg#arrow-left-circle"></use>
		    </svg>
		  </button>
		`;
	}

	show() {
		const backButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		backButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const backButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		backButton?.classList?.add(ClassNames.Hidden);
	}
}
